module.exports = __webpack_public_path__ + "static/img/0005.c6e5515.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0005.png
// module id = CR46
// module chunks = 1